// extracted by mini-css-extract-plugin
module.exports = {"span":"galleryPage-module--span--2E6dO","isShady":"galleryPage-module--isShady--1P6Ut","flyintoright":"galleryPage-module--flyintoright--XIoVI"};